<template>
    <div>
        <div :style="boxdimensions">
            <div class="image-placeholder w-auto h-full flex flex-col justify-center rounded overflow-hidden">
              <img v-if="image" :src="image" class="w-full block" :alt="alt ? alt : name">
              <div v-else class="w-full flex flex-col justify-center items-center gap-4">
                <feather-icon icon="ImageIcon" svgClasses="h-16 w-16 text-primary" />
                <p v-if="constraintsText" class="text-xs font-semibold">{{ constraintsText }}</p>
              </div>
            </div>
        </div>
        <div class="mt-3 flex flex-row gap-2 items-center">
            <vs-button :disabled="disabled" type="border" class="button-select-image inline-block rounded-lg py-2" @click="handlerChooseFiles()">{{ $t("image.select.image") }}</vs-button>

            <vs-button :disabled="disabled" v-if="image" type="border" color="danger" class="delete-row rounded-lg px-3 py-2 text-danger" @click="handlerDelete">
                <feather-icon icon="TrashIcon" class="align-middle" svgClasses="align-middle w-4"/>
            </vs-button>
        </div>
        <vs-input
            type="file"
            :name="name"
            hidden
            ref="input"
            @change="onFileChange"
            :danger="validateError"
            :danger-text="validationMessage"
        />
    </div>
</template>

<script>

export default {
    name: 'image-form-form',
    props:{
        'src': String,
        'value': String,
        'name': String,
        'alt': String,
        'width': String,
        'height': String,
        'validSizes': {
          required: false,
          type: Array,
          default: () => []
        },
        'validationWidthEqualsHeight': {
            'type': Boolean,
            'default': false
        },
        'validationWeight': String,
        'validationMessage': String,

        'constraintsText': String,
        'disabled': {
          'type': Boolean,
          'default': false
        },
    },
    computed: {
        boxdimensions() {
            return `width:${this.width}px;height:${this.height}px`;
        },
        image() {
            if (this.imageData) {
                return this.imageData
            }

            if (this.value) {
                return this.value
            }

            return this.src
        }
    },
    data() {
        return {
            imageData: null,
            validateError: false
        }
    },
    watch: {
      'src': function() {
        this.imageData = null
      },
      'value': function(value) {
          this.src = value
      }
    },
    methods: {
        handlerChooseFiles() {
            this.$refs.input.$el.querySelector('input').click()
        },
        onFileChange(e) {
            const file = e.target.files[0];
            const image = URL.createObjectURL(file);
            const img = new Image();
            const that = this;

            img.src = image;
            img.onload = (function() {
                let invalidSize = false;
                if (that.validSizes.length) {
                  invalidSize = !that.validSizes.some(({width, height}) => width == this.width && height == this.height)
                }

                const validationWeightError = that.validationWeight ? that.validationWeight < file.size / 1024 : false;

                let errorCondition = validationWeightError || invalidSize

                if(that.validationWidthEqualsHeight) {
                    const validationWidthEqualsHeightError = this.height !== this.width;
                    errorCondition = errorCondition || validationWidthEqualsHeightError
                }

                if ( errorCondition ) {
                    that.validateError = true
                } else {
                    that.imageData = image;
                    that.$emit('updateImage', file)
                    that.$emit('input', image)
                    that.validateError = false;
                }
            })
        },
        handlerDelete() {
            this.$emit('input', this.imageData)
            this.imageData = null;
            this.$emit('updateImage', null)
        }
    }
}
</script>

<style scoped>

.image-placeholder {
  background-color: #F4F4FA;
}
</style>
